import {CardBoxComponent} from './card-box.component';
import {CardBoxComponentInline} from './card-box.inline.component';
import {CardBoxHeaderComponent} from './card-box.header.component';
import {CardBoxContentComponent} from './card-box.content.component';
import {CardBoxActionComponent} from './card-box.action.component';
import {CardBoxProfileContentResolver} from './card-box.profile.content.resolver';
import {CardBoxPrivateContentComponent} from './card-content/card-box-private.content.component';
import {CardBoxCorporateContentComponent} from './card-content/card-box-corporate.content.component';


export const CARD_BOX_COMPONENTS = [
    CardBoxComponent,
    CardBoxComponentInline,
    CardBoxHeaderComponent,
    CardBoxActionComponent,
    CardBoxContentComponent,
    CardBoxProfileContentResolver,
    CardBoxPrivateContentComponent,
    CardBoxCorporateContentComponent,
];



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/card-box/index.ts